import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/sT-logo.jpg")